// extracted by mini-css-extract-plugin
export default {"container":"ForwardTo_container_yjHBv","list":"ForwardTo_list_LW5xt"};